import { Box, CircularProgress, Typography } from '@mui/material';

const PDF_BOX_SX = {
    border: '1px solid #ddd',
    borderRadius: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    bgcolor: '#fafafa'
};

function PdfPreviewBox({ title, loading, url, height, flexGrow = false }) {
    const previewBoxSx = flexGrow
        ? { ...PDF_BOX_SX, flex: 1, minHeight: 0 }
        : { ...PDF_BOX_SX, height };

    return (
        <Box sx={flexGrow ? {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
        } : {
            mb: 2,
            '&:last-of-type': { mb: 0 }
        }}>
            {title ? (
                <Typography variant="subtitle2" sx={{ mb: 1, flexShrink: 0 }}>{title}</Typography>
            ) : null}
            <Box sx={previewBoxSx}>
                {loading ? (
                    <CircularProgress />
                ) : url ? (
                    <iframe
                        src={url}
                        title={title || 'PDF Önizleme'}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    />
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Önizleme yüklenemedi
                    </Typography>
                )}
            </Box>
        </Box>
    );
}

export default PdfPreviewBox;
